export default __webpack_public_path__ + "static/media/Doubly_List_Deletion_3.83a9c1cc.gif";